export default {
    username: "Nome do usuário",
    password: "Senha",
    button: "Entrar",
    error: "Erro ao logar, confira suas informações",
    page_title: "Kevi | Login",
    pattern_alt: "Vetor decorativo",
    logo_alt: "Logo da Kevi",
    promo_alt: "Imagem promocional",
    username_placeholder: "Digite seu usuário",
    password_placeholder: "**********************",
    forgot_password: "Esqueceu sua senha?",
    contact_support: "Entrar em contato",
    access_account_title: "Acesse sua conta",
    access_account_subtitle:
        "Gerencie suas campanhas, automatize suas ações e fidelize seus clientes.",
    auth_granted_title: "Autorização Concedida",
    auth_granted_subtitle: "Você autorizou <strong>{0}</strong> com sucesso.",
    go_to_client: "Ir para {0}",
    auth_access_title: "Autorizar Acesso",
    logged_in_as: "Você está conectado como <strong>{0}</strong>.",
    authorize_access_question:
        "Deseja autorizar o acesso a <strong>{0}</strong>?",
    yes_authorize: "Sim, Autorizar",
    switch_account: "Não é você? Trocar de conta",
    login_to_authorize:
        "Faça login na Kevi para autorizar o acesso a <strong>{0}</strong>.",
    authorize_button: "Autorizar",
    invalid_redirect_uri: "URL de redirecionamento inválida.",
    auth_code_generation_failed: "Falha ao gerar código de autorização.",
    session_expired: "Sessão expirada. Por favor, faça login novamente.",
    server_connection_error: "Erro ao conectar com servidor.",
    oauth_access_code_missing:
        "Falha na autorização. O código de acesso não foi retornado.",
    redirect_missing_info:
        "Falha ao redirecionar. Informações da aplicação ausentes.",
    popup_blocked:
        "O redirecionamento foi bloqueado. Por favor, habilite pop-ups para este site.",
    twofa: {
        title: "AUTENTICAÇÃO DE 2 FATORES",
        subtitle: "Digite o código de 6 dígitos gerado no seu app autenticador",
        verify_button: "Verificar",
        use_backup: "Ou use um dos seus códigos backup.",
        click_here: "Clique aqui.",
        error_auth:
            "Falha na autorização. O código de acesso não foi encontrado após a verificação.",
        error_invalid: "Código inválido ou expirado. Tente novamente.",
        error_too_many: "Muitas tentativas. Entre com sua senha novamente.",
        error_expired: "O tempo para confirmar o código acabou. Entre com sua senha novamente.",
        error_code_used: "Este código de recuperação já foi usado.",
    },
    backup: {
        title: "Digite seu código de backup",
        subtitle: "Insira um dos seus códigos de backup de 8 dígitos",
        use_authenticator: "Caso prefira, use um dos seus ",
        code_link: "códigos autenticadores",
    },
    recovery: {
        link: "Recuperar senha",
        title: "Recuperar senha",
        subtitle: "Informe o usuário ou e-mail da sua conta. Enviamos um código para você criar uma nova senha.",
        identifier_label: "Digite seu usuário ou e-mail",
        identifier_placeholder: "Digite seu usuário ou e-mail",
        continue: "Continuar",
        choose_title: "Escolha um canal",
        choose_subtitle: "Você possui duas formas de contato, para onde deseja receber o código?",
        email: "E-mail",
        sms: "SMS",
        code_title: "Digite o código",
        code_subtitle: "Enviamos um código de 6 dígitos para {0}.",
        resend_prefix: "Não recebeu o código?",
        resend_action: "Clique aqui.",
        verify: "Verificar",
        password_title: "Crie uma nova senha",
        password_hint: "Use no mínimo 8 caracteres.",
        new_password: "Nova senha",
        repeat_password: "Repita a nova senha",
        save: "Salvar nova senha",
        success_title: "Senha alterada<br>com sucesso!",
        success_subtitle: "Use a nova senha para entrar.",
        back_to_login: "Voltar ao login",
        blocked_title: "Não é possível<br>recuperar sua senha",
        blocked_subtitle: "Esta conta não tem e-mail ou telefone verificado. Peça a um administrador da sua empresa para definir uma senha temporária para você.",
        blocked_back: "Voltar para o login",
        invalid_code: "Código inválido ou expirado. Tente novamente.",
        mismatch: "As senhas não são iguais.",
        weak: "Use no mínimo 8 caracteres.",
        too_many: "Muitas tentativas. Tente novamente mais tarde.",
        send_failed: "Não foi possível enviar o código. Tente novamente.",
        code_valid: "Válido por 15 minutos.",
        change_identifier: "Voltar",
        resend_in: "Reenviar em {0}",
        resent: "Enviamos um novo código.",
        expired: "O código expirou. Peça um novo código.",
        too_many_attempts: "Muitas tentativas com este código. Peça um novo código.",
        network: "Não foi possível conectar. Tente novamente.",
    },
};
